import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';

export const ExportComplianceNotice = () => (
  <div
    className="mt-10 rounded-2xl border border-slate-200/80 bg-slate-50/70 p-6 md:p-7 flex flex-col md:flex-row md:items-start gap-5"
    data-testid="export-compliance-notice"
  >
    <span className="w-11 h-11 rounded-xl bg-white border border-slate-200 shadow-sm flex items-center justify-center shrink-0">
      <ShieldCheck className="w-5 h-5 text-[#0096D6]" />
    </span>
    <div className="flex-1">
      <p className="font-outfit text-sm font-semibold text-slate-900 tracking-wide uppercase mb-2">Export-Controlled Products</p>
      <p className="font-manrope text-sm text-slate-600 leading-relaxed">
        Certain advanced computing products may be subject to export controls, sanctions, licensing requirements and geographic or end-use restrictions. Availability is therefore subject to destination, customer, end-user and end-use verification. Products will not be supplied where a transaction would breach applicable export-control or sanctions laws.
      </p>
      <Link to="/compliance" className="inline-flex items-center gap-1 mt-3 font-manrope text-sm font-semibold text-[#0096D6] hover:underline" data-testid="compliance-learn-more-link">
        Learn about purchasing requirements <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </div>
);
